import { render, staticRenderFns } from "./Present.vue?vue&type=template&id=712c32f0&scoped=true"
import script from "./Present.vue?vue&type=script&lang=js"
export * from "./Present.vue?vue&type=script&lang=js"
import style0 from "./Present.vue?vue&type=style&index=0&id=712c32f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c32f0",
  null
  
)

export default component.exports